import React from 'react';

const Containment: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className="containment">{children}</div>
);

export default Containment;
